import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Accordion, { headerStyle } from '../Accordion';
import Job from './Job';
import { greenhouseFilters } from '../../selectors';

const DepartmentJobs = ({
  departmentJobs,
  classes,
  isChild,
  departmentIdFilter,
}) => (
  <div>
    <div key={departmentJobs.departmentId} className={classes.departmentContainer} style={isChild ? { marginLeft: '15px', marginBottom: '15px' } : undefined}>
      {/* eslint-disable-next-line react/prop-types */}
      <Accordion hidden={departmentIdFilter === 0} className={{ header: classes.department }} headerTitle={`${departmentJobs.departmentName} (${departmentJobs.totalJobs})`}>
        {departmentJobs.jobs.map(job => (
          <Job job={job} key={job.id} />
        ))}

        {departmentJobs.children.map(child => (
          <DepartmentJobs
            departmentJobs={child}
            key={child.departmentId}
            isChild
            departmentIdFilter={departmentIdFilter}
            classes={classes}
          />
        ))}
      </Accordion>
    </div>
  </div>
);

DepartmentJobs.propTypes = {
  departmentIdFilter: PropTypes.number,
  isChild: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  departmentJobs: PropTypes.shape({
    departmentId: PropTypes.number.isRequired,
    departmentName: PropTypes.string.isRequired,
    jobs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
      }),
    ),
    children: PropTypes.arrayOf(PropTypes.shape({
      departmentId: PropTypes.number.isRequired,
      departmentName: PropTypes.string.isRequired,
      jobs: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          location: PropTypes.string.isRequired,
        }),
      ),
    })),
  }).isRequired,
};

DepartmentJobs.defaultProps = {
  isChild: false,
  departmentIdFilter: 0,
};

const mapStateToProps = state => ({
  ...state,
  departmentIdFilter: greenhouseFilters(state).departmentId,
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    departmentContainer: {
      marginBottom: '15px',
    },
    department: {
      ...headerStyle,
      padding: '16px 0px 16px',

      borderBottom: '1px solid #DFDFDF',

      fontStyle: 'normal',
      fontWeight: '700',
      fontSize: '24px',
      lineHeight: '36px',

      width: '100%',
    },
  }),
)(DepartmentJobs);
